import { DateTime } from 'luxon';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { forkJoin } from 'rxjs';
import { ApplicationPaths, QueryParameterNames } from 'src/api-authorization/api-authorization.constants';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { MyScore, Scores } from 'src/models/myscores.model';
import { Player } from 'src/models/player.model';
import { Score } from 'src/models/score.model';
import { UserService } from 'src/services/user.service';
import { DialogDoublesNameComponent } from '../dialogs/dialogChangeDoublesName.component';
import { PlayerService } from '../players/players.service';
import { ProfileService } from '../profile/profile.service';
import { DOCUMENT } from '@angular/common';

export const REGISTRATION_OPEN = true;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['home.component.scss']
})
export class HomeComponent implements OnInit {
  public busy: boolean = false;
  //public isAuthenticated: boolean = false;
  public player: Player = new Player();
  public scores: Scores = new Scores();
  public debug: boolean = false;
  public faTrash = faTrashAlt;
  public isTiebreakTourney: boolean = false;
  public avatar?: string;
  public ladderEnded: boolean = false;
  public ladderEndDate: string = '';
  public REGISTRATION_OPEN: boolean = REGISTRATION_OPEN;
  public isStalker: boolean = false;
  public isWaitingRoom: boolean = false;
  // only used in waiting room
  public players: Player[][] = [];

  constructor(private authorizeService: AuthorizeService,
    private userSvc: UserService, private http: HttpClient,
    private router: Router, private playerSvc: PlayerService,
    private dialog: MatDialog, public renderer: Renderer2,
    private profileSvc: ProfileService, @Inject(DOCUMENT) private document: Document,
    private aRoute: ActivatedRoute, private cdr: ChangeDetectorRef) {
    this.busy = true;

    this.aRoute.queryParams.subscribe(params => this.debug = !!params.debug);
  }

  async ngOnInit() {
    const p1 = this.userSvc.getUser();
    const p2 = this.playerSvc.getScores();

    forkJoin([p1, p2]).subscribe(
      ([resp1, resp2]) => {
        this.player = new Player(resp1);

        if (this.player.levelId == 1) this.setStalker(true);
        else this.setStalker(false);

        if (this.player.ladderId == 'WAITING_ROOM' || this.player.ladderId == 'WAITING_ROOM_DOUBLES')
          this.setWaitingRoom();
        this.isTiebreakTourney = this.player.ladderType == 'Tiebreak';
        // hardcode the first result when we are player one... because only one result will be returned
        // from the scores API when we request the main logged in player... (we get their ladder and level data)
        // --- as opposed to looking at someone ELSE where we get all their levels...
        this.scores = new Scores(resp2.results[0]);
        console.log('in HOME.ts - get avatar')
        this.profileSvc.getAvatar(this.player.id).subscribe(
          (resp) => {

          this.avatar = resp.base64img;
          console.log('in HOME.ts - got avatar');
          },
          (err) => console.log('no avatar found')
        );


        this.ladderEnded = this.scores.ladderEnded;
        this.ladderEndDate = DateTime.fromJSDate(new Date(this.scores.ladderEndDate)).toLocaleString(DateTime.DATE_MED);
        this.busy = false;
        this.cdr.markForCheck();
      },
      (err) => {
        this.busy = false;
        this.cdr.markForCheck();
        if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
          this.router.navigate(ApplicationPaths.LoginPathComponents, {
            queryParams: { [QueryParameterNames.ReturnUrl]: this.router.url }
          });
        }
      }
    );
  }

  public setStalker(bFlag: boolean) {
    this.isStalker = bFlag;
    const elms = ['myrecord','players', 'standings', 'footer']
    for( let _elm of elms ) {
      let elm = this.document.getElementById(_elm);
      if (elm && bFlag) this.renderer.addClass(elm, 'hideme');
      if (elm && !bFlag) this.renderer.removeClass(elm, 'hideme');
    }
  }
  public setWaitingRoom() {
    this.isWaitingRoom = true;
    let elm = this.document.getElementById("players");
    if (elm) this.renderer.addClass(elm, 'hideme');
    elm = this.document.getElementById("standings");
    if (elm) this.renderer.addClass(elm, 'hideme');
    const elm2 = this.document.getElementById("footer");
    if (elm2) this.renderer.addClass(elm2, 'hideme');
  }
  public ngOnDestroy(): void {
    const elm = this.document.getElementById("nav-menu");
    if (elm) this.renderer.removeClass(elm, 'hideme');
    const elm2 = this.document.getElementById("footer");
    if (elm2) this.renderer.removeClass(elm2, 'hideme');
  }


  public delete(evt: any, id: number, name: string) {
    if (confirm(`Are you sure you want to delete this match/score against ${name}?`)) {
      this.http.delete(`/match/${id}`).subscribe(
        (resp) => {
          this.playerSvc.getScores().subscribe(
            (resp) => {
              this.scores.scores.length = 0;
              this.scores = new Scores(resp.results[0]);
            },
            (err) => console.error("unable to query scores")
          )
        },
        (err) => console.error(err)
      )
    }
  }
  public changeDoublesName(evt: any) {
    evt.preventDefault();
    const dialogConfig = new MatDialogConfig();
    const dRef = this.dialog.open(DialogDoublesNameComponent, dialogConfig);
    dRef.afterClosed().subscribe(
      (teamName: string) => this.player.doublesName = teamName
    )
  }

  public getCssClass(s: MyScore) {
    if (s.points >= 3) return 'win';
    if (s.score == 'FORFEIT' && s.points > 0) return 'win';

    //{ 'win': s.points == 3, 'loss': s.points < 3 }
    return 'loss';
  }
}
